import type { Theme } from '@mui/material/styles';
import {
    Border,
    Spacing,
} from '@uipath/apollo-core';

// Shared frame of a V2 unit card and its loading skeleton.
export const consumableCardFrame = (theme: Theme) => ({
    border: `1px solid ${theme.palette.semantic.colorBorderDeEmp}`,
    borderRadius: Border.BorderRadiusL,
    padding: Spacing.SpacingBase,
    display: 'flex' as const,
    flexDirection: 'column' as const,
    minWidth: 0,
});
